import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";
import './styles.css'; // 引入全局样式文件

Vue.prototype.$eventBus = new Vue();
// 粒子
import VueParticles from "vue-particles";
Vue.use(VueParticles);
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)
// 引入axios
import axios from "axios";
Vue.prototype.axios = axios;
// 设置Axios请求拦截器
axios.interceptors.request.use(function (config) {
  let token = sessionStorage.getItem("token"); // 获取到从后端传来的token，然后存到session里面
  if (token) {
    config.headers["token"] = token; // 然后赋值就行
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 设置Axios响应拦截器
axios.interceptors.response.use(async function (response) {
  if (response.data.code === 1001 && response.data.info === "token过期!" && !store.state.isShowingTokenExpiredPrompt) {
    store.commit('setIsShowingTokenExpiredPrompt', true);
    try {
      await Vue.prototype.$confirm('登录已过期，请重新登录', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      });
      sessionStorage.removeItem('token');
      router.push('/login');
      Vue.prototype.$message({
        type: 'success',
        message: '返回成功!'
      });
    } catch (e) {
      // 用户取消操作
    } finally {
      store.commit('setIsShowingTokenExpiredPrompt', false);
    }
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});

// 引入echarts
import * as echarts from "echarts";
Vue.prototype.echarts = echarts;

// 引入ElementUI组件
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import { createPinia, PiniaVuePlugin } from 'pinia'
import VueCompositionAPI from '@vue/composition-api'

// 引入pinia
Vue.use(VueCompositionAPI)
Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  pinia,
  render: (h) => h(App),
}).$mount("#app");
